import React, { useEffect, useState } from 'react'
import { useSnackbar } from '../../../../context/SnackBarContext'
import { formatPuchaseEditOrder, formatPuchaseOrder } from '../../../../utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import EditPuchaseOrderTable from './EditPuchaseOrderTable';
import fetcher from '../../../../helper/fetcher';
import { useGetPurchaseItems } from '../../../../hooks/purchaseOrder';
import { CustomSearch } from "../../../../component/CustomSearch"
import { SideDrawer } from "../../../../component/SideDrawer/SideDrawer"
import WarningModal from "../../../../component/WarningModal"
import { EditPurchaseOrderForm } from './EditPurchaseOrderForm';

const EditPurchaseOrder = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const editData = location.state.data

    console.log("editData ==>>>", editData)

    const { showSuccess, showError } = useSnackbar();
    const { product: productsName, params, setParams } = useGetPurchaseItems();
    const [drawerOpen, setDrawerOpen] = useState(false);
    // const [selectedItm, setSelectedItem] = useState(null)
    const [state, setState] = useState({
        isModalOpen: false,
        selectedContact: null,
        isDrawerOpen: false,
        isContactDrawerOpen: false,
        isProductDrawerOpen: false,
        availableUser: [],
        isLoading: false,
        searchQuery: '',
        memo: '',
        attachment: null,
    })
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        supplier: '',
        size: '',
        fabricator: '',
        styleNo: '',
        styleName: '',
        remarks: '',
        orderNo: '',
        dated: '',
        deliveryDate: '',
        deliveryAt: '',
        issueQuantity: '',
        total: '',
        color: ''
    });
    const [tableData, setTableData] = useState({
        productId: "",
        item: [{
            item_name: "",
            avg: 0,
            colQty: 0,
            quantity: 0,
            unit: '',
            rate: 0,
            total: 0,
        }],
    });

    const updateState = (data) => {
        setState((prevState) => {
            const newState = { ...prevState, ...data }
            return newState
        })
    }

    useEffect(() => {
        if (editData) {
            const issueQty = Number(editData.issue_quantity);
            setFormData({
                supplier: editData.suppiler || "", // note: original key is `suppiler`, not `supplier`
                size: editData.size || "",
                fabricator: editData.fabricator || "",
                styleNo: editData.style_no || "",  // style_no from editData
                styleName: editData.style_name || "",
                remarks: editData.remarks || "",
                orderNo: editData.order_no || "",
                dated: editData.dated || "",
                deliveryDate: editData.delivery_date || "",
                deliveryAt: editData.delivery_at || "",
                issueQuantity: editData.issue_quantity || "",
                total: editData.total || "",
                color: editData.color || ""
            });

            setTableData({
                productId: editData?.itemId?._id,
                item: (editData?.itemId?.item).map((itm) => {
                    const avg = parseFloat(itm.avg_pics).toFixed(2);
                    const rate = parseFloat(itm.rate).toFixed(2);

                    return {
                        item_name: itm.item_name || "",
                        avg: parseFloat(avg),
                        colQty: Number(((issueQty / 4) * avg).toFixed(2)),
                        quantity: Number((issueQty * avg).toFixed(2)),
                        unit: itm.unit || '',
                        rate: parseFloat(rate),
                        total: Number((issueQty * avg * rate).toFixed(2))
                    };
                })
            });
        }
    }, [editData]);

    const toggleDrawer = () => setDrawerOpen(!drawerOpen);

    const handleSaveOrder = () => {
        updateState({ isLoading: true })
        const payLoadData = formatPuchaseEditOrder(formData, tableData)
        fetcher.patch(`/inventory/purchase/update_purchase/${editData._id}`, payLoadData)
            .then((response) => {
                showSuccess(response.data.message|| "Updated Successfully ")
                setTimeout(() => {
                    navigate("/inventory/manage-purchase-order")
                }, 2000)
            })
            .catch((err) => {
                showError(err.response?.data?.message || "Failed to fetch job data");
            }).finally(() => {
                updateState({ isLoading: false })
            })
    }

    const handleSelectedProduct = (selectedItem) => {
        const newProductId = selectedItem._id || "";
        const newStyleName = selectedItem.styleName;
        // Generate new item entries
        const newItems = selectedItem.item.map((itm) => {
            const avg = parseFloat(itm.avg_pics).toFixed(2) || 0;
            const rate = parseFloat(itm.rate).toFixed(2) || 0;
            const issueQty = parseFloat(formData.issueQuantity).toFixed(2) || 0;
            return {
                item_name: itm.item_name || "",
                avg: avg,
                colQty: Number(((issueQty / 4) * avg).toFixed(2)),
                quantity: Number((issueQty * avg).toFixed(2)),
                unit: itm.unit,
                rate: rate,
                total: Number((issueQty * avg * rate).toFixed(2)),
            };
        });

        // Update table data by appending new items
        setTableData((prev) => ({
            productId: newProductId,
            item: [...newItems]
        }));

        setFormData((prev) => ({ ...prev, styleName: newStyleName }));
        updateState({ isProductDrawerOpen: false });
        // setSelectedItem(selectedItem)
    };

    const handleAddProduct = () => {
        updateState({ isProductDrawerOpen: false });
        toggleDrawer();
    }

    console.log("formData ===", formData, "tableData ===>>", tableData, "producttttttttt")
    return (
        <div className='bg-white rounded-lg pb-12 min-h-screen'>
            <EditPurchaseOrderForm
                state={state}
                updateFunc={updateState}
                formData={formData}
                handleSaveOrder={handleSaveOrder}
                setFormData={setFormData}
                setModalOpen={setModalOpen}
                tableData={tableData}
                modalOpen={modalOpen}
                setTableData={setTableData}
            />
            <EditPuchaseOrderTable
                state={state}
                setTableData={setTableData}
                updateFunc={updateState}
                tableData={tableData}
                formData={formData}
            />

            <SideDrawer
                open={state.isProductDrawerOpen}
                onClose={() => updateState({ isProductDrawerOpen: false })}
                title="Add Product"
                headerHidden
            >
                <div className="px-4">
                    <CustomSearch value={params.query} onChange={(e) => setParams((prev) => ({ ...prev, query: e.target.value }))} />
                    <div className="pt-4 max-h-[80vh] overflow-y-auto">
                        {productsName.results?.length > 0 &&
                            productsName.results.map((item, index) => (
                                <p key={index} onClick={() => handleSelectedProduct(item)} className="cursor-pointer hover:text-[#db3647] p-1">
                                    {item.styleName}
                                </p>
                            ))}
                    </div>
                    <div className="flex justify-between items-center">
                        <button onClick={handleAddProduct} className="bg-[#db3647] text-white px-4 py-2 rounded">
                            +Add New
                        </button>
                    </div>
                </div>
            </SideDrawer>

            <WarningModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                modalTitle="Are you sure you want to save this Puchase Order?"
                onConfirm={handleSaveOrder}
                onCancel={() => setModalOpen(false)}
                confirmText="Yes, Confirm"
                cancelText="Cancel"
                isLoading={state.isLoading}
                color={false}
            />
        </div>
    )
}

export default EditPurchaseOrder
